import { Constants } from '@leverege/molten';
import Alerts from './Alerts';
export default {
  install(molten) {
    molten.addPlugin(Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, Alerts);
  }
};